<!-- 注册隐私协议 -->
<template>
    <el-dialog :visible.sync="visible"
               v-if='visible'
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               width="40%">
  
      <!-- <template slot="title">
        {{ $t('agreement.title') }}
      </template> -->
     
      <body style="text-align:justify;overflow-y: auto;padding: 0px 14px 0 14px;background: #ffff;font-size: 12.5pt; widows:0; orphans:0; font-family:等线,sans-serif; font-size:10.5pt">
    <div>
        <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:12.5pt"><span
                style="font-family:宋体;font-weight: 600;">个人信息共享情况说明</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-align:center; font-size:12.5pt"><span
                style="font-family:'.PingFangSC-Regular'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; font-size:12.5pt"><span
                style="font-family:宋体">您所受雇的经销商（公司）及所属经销商集团正在向我们申请共享您的姓名、电子邮件、电话号码、学习记录及相关考核结果，实现为您提供更有侧重和帮助的服务，例如：共享学习管理、能力考核、荣誉职级的统计数据等。如您点击</span><span
                style="font-family:'.PingFangSC-Regular'">“</span><span style="font-family:宋体">同意</span><span
                style="font-family:'.PingFangSC-Regular'">”</span><span style="font-family:宋体">选项，我们将向其共享您的上述信息。</span>
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; font-size:12.5pt"><span
                style="font-family:'.PingFangSC-Regular'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; font-size:12.5pt"><span
                style="font-family:宋体">您所受雇的经销商（公司）及所属经销商集团将在上述处理目的、处理方式和个人信息种类范内对您的个人信息进行处理。如有任何问题，您可以联系通过悦学院《宝马个人信息保护政策》
                联系我们，也可以通过您的雇主联系接收方。</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; font-size:12.5pt"><span
                style="font-family:'.PingFangSC-Regular'; -aw-import:ignore">&#xa0;</span></p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; font-size:12.5pt"><span
                style="font-family:宋体">有关我们处理个人信息的完整内容，请参见《宝马个人信息保护政策》。</span></p>
    </div>
</body>
      <template slot="footer">
        <el-button type="button"
                   class="buttonqx"
                   :disabled="disabled"
                   @click="visible = false">同意</el-button>
      </template>
    </el-dialog>
  </template>
  <script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        visible: false,
        disabled: true
      }
    },
    methods: {
      init() {
        this.visible = true
        this.$nextTick(() => {
          this.getConfirm(0)
        })
      },
      getConfirm(time) {
        var _this = this
        if (time === 0) {
          this.disabled = false
          $('.buttonqx').html(this.$t('confirm'))
        } else {
          // 按钮不可用
          this.disabled = true
          $('.buttonqx').html(this.$t('agreement.confirm', { 'handle': time }))
          time--
          setTimeout(function () {
            _this.getConfirm(time)
          }, 1000)
        }
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .el-input-number {
    width: 100% !important;
  }
  .el-input__inner {
    text-align: left !important;
  }
  .buttonqx {
    margin: 0px !important;
    width: 100%;
    // background-color: #1b69d4;
    color: #fff;
    border: 0px;
    line-height: 25px;
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #666;
    background-color: #eee;
  }
  .el-button.el-button--default.is-disabled:hover {
    color: #666;
    background-color: #eee !important;
  }
  .el-button.el-button--default.is-disabled {
    color: #666;
    background-color: #eee !important;
  }
  .el-button.el-button--default {
    color: #fff;
    background-color: #5c9df5 !important;
    border-color: #5c9df5;
  }
  .buttomqr {
    margin-left: 0px !important;
    float: left !important;
    width: 100% !important;
    line-height: 23px;
  }
  .el-dialog__body div {
    // margin-top: 16px;
    line-height: 20px;
    overflow: auto;
    width: 100%;
    height: 30em;
  }
  .el-dialog__header {
      text-align: center;
      font-size: 18px;
  }
  .agree p{
      font-family: 等线, sans-serif;
  }
  .center{
    text-align:center;
  }
  .span2{
    padding-left:2em;
  }
  .span4{
    padding-left:4em;
  }
  .span6{
    padding-left:6em;
  }
  </style>
  